/* eslint-disable */
export default {
  notActivated: 'Inaktiv',
} as const;

// @key: @#@"notActivated"@#@ @source: @#@"Inactive"@#@
